import InspectionProfileTableData from "./inspectionProfileTableData";
import generateDefaultProviderPanelRow from "./defaultProviderPanelRow";
import { AccuracyInspectionSupplement } from "@app/projects/results/accuracy/accuracyInspectionSupplement";

const providerTelehealthOriginatingSiteRowKeys: string[] = [];

/* oxlint-disable sort-keys */
export const generateProviderTelehealthOriginatingSiteRow = (rowKey: string, title: string, supplements: AccuracyInspectionSupplement<string>[]): InspectionProfileTableData[] => {
  const tableData: InspectionProfileTableData[] = [];

  if (supplements && supplements.length > 0) {
    supplements.forEach((supplement : AccuracyInspectionSupplement<string>, index : number) => {
      const currentRowTitle = index === 0 ? title : "";
      const currentRowKey = `${rowKey}-${index}`;
      providerTelehealthOriginatingSiteRowKeys.push(currentRowKey);

      tableData.push(generateDefaultProviderPanelRow(currentRowKey, currentRowTitle, null, supplement));
    });
  } else {
    providerTelehealthOriginatingSiteRowKeys.push(rowKey);
    tableData.push(
      generateDefaultProviderPanelRow(rowKey, title, null, null)
    );
  }

  return tableData;
}

export const getProviderTelehealthOriginatingSiteRowKeys = () : string[] => providerTelehealthOriginatingSiteRowKeys;